"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreeDStructureScene = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _drei = require("@react-three/drei");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Scene = _interopRequireDefault(require("../../../components/Viewer/Scene"));
var _SceneContainer = _interopRequireDefault(require("../../../components/Viewer/SceneContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ThreeDStructureScene = _ref => {
  let {
    canvasClassName
  } = _ref;
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_reactRedux.ReactReduxContext.Consumer, null, _ref2 => {
    let {
      store
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Scene.default, {
      canvasClassName: canvasClassName
    }, /*#__PURE__*/_react.default.createElement(_drei.Bounds, {
      fit: true,
      clip: true,
      observe: true,
      margin: 1.1,
      damping: 3,
      eps: 0.5
    }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
      store: store
    }, /*#__PURE__*/_react.default.createElement(_SceneContainer.default, null))));
  }), [canvasClassName]);
};
exports.ThreeDStructureScene = ThreeDStructureScene;
ThreeDStructureScene.propTypes = {
  canvasClassName: _propTypes.default.string
};